import type { MapStateToPropsFactory } from 'react-redux';
import { connect } from 'react-redux';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { secondaryMarketQuoteRequestThunk } from 'state/secondaryMarket/realtimeQuote/quote/quote.thunks';
import type { SecondaryMarketQuoteRtForm } from 'state/secondaryMarket/realtimeQuote/realtimeQuoteForm/realtimeQuoteForm.model';
import { makeGetSecondaryMarketRtFormValidationErrors } from 'state/secondaryMarket/realtimeQuote/realtimeQuoteForm/realTimeQuoteForm.selectors';
import { getSecondaryMarketRealtimeAstroProducLifecycleUrl } from 'state/secondaryMarket/referential/astroProduct/astroProduct.selectors';
import type { SecondaryMarketFormError } from 'state/secondaryMarket/shared/form/validationResults';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

type OwnProps = Readonly<{
  tabId: string;
  isReady: boolean;
}>;

type StateProps = Readonly<{
  lifecycleUrl: string | null;
  validationErrors: SecondaryMarketFormError<SecondaryMarketQuoteRtForm>[];
}>;

type DispatchProps = Readonly<{
  onGetQuote: () => void;
}>;
export type InitialQuoteSidePanelProps = OwnProps & StateProps & DispatchProps;

const readyToQuote: SecondaryMarketFormError<SecondaryMarketQuoteRtForm>[] = [
  {
    fields: [],
    severity: 'Warning',
    translationKey: 'readyToQuote',
    values: {},
  },
];

const mapStateToProps: MapStateToPropsFactory<StateProps, OwnProps, AppState> = () => {
  const getValidationErrors = makeGetSecondaryMarketRtFormValidationErrors();
  return (state: AppState, { tabId }: OwnProps): StateProps => {
    const lifecycleUrl = getSecondaryMarketRealtimeAstroProducLifecycleUrl(state, tabId);
    const formErrors = getValidationErrors(state, tabId);
    return {
      lifecycleUrl,
      validationErrors: formErrors.length > 0 ? formErrors : readyToQuote,
    };
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): DispatchProps => {
  return {
    onGetQuote() {
      dispatch(secondaryMarketQuoteRequestThunk(tabId));
      logAnalytics.trackEvent('Secondary market', 'Request for quote');
    },
  };
};
export const connectInitialQuoteSidePanel = connect(mapStateToProps, mapDispatchToProps);
